import { render, staticRenderFns } from "./breed-add-edit-component.vue?vue&type=template&id=0804035b&scoped=true&lang=pug"
import script from "./breed-add-edit-component.js?vue&type=script&lang=js&external"
export * from "./breed-add-edit-component.js?vue&type=script&lang=js&external"
import style0 from "./breed-add-edit-component.vue?vue&type=style&index=0&id=0804035b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0804035b",
  null
  
)

export default component.exports